/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const topSearchCategories = {
    /**
     * Get categories
     *
     * @param {Array} facets
     * @returns {Array}
     */
    getCategories(facets) {
        const categoriesFacet = facets.find(f => f.attribute === 'categories')
        if (!categoriesFacet) {
            return []
        }

        const sortedBuckets = this.sortCategoriesByGender(categoriesFacet.buckets)

        return sortedBuckets
            .filter(b => b.title.includes('/'))
            .map(b => ({
                ...b,
                url: `${this.baseUrl}${b.title}`,
                path: this.formatCategoryPath(b.title),
                title: b.name
            }))
    },
    /**
     * Sort categories according active gender cookie
     *
     * @param categories
     * @returns {*}
     */
    sortCategoriesByGender(categories) {
        const cookie = hyva.getCookie('mey-gender')
        const women = this.translations.women.toLowerCase()
        const men = this.translations.men.toLowerCase()

        return categories.sort((a, b) => {
            const aIsMen = a.title.toLowerCase().includes(men)
            const bIsMen = b.title.toLowerCase().includes(men)
            const aIsWomen = a.title.toLowerCase().includes(women)
            const bIsWomen = b.title.toLowerCase().includes(women)

            if (cookie === 'm') {
                if (aIsMen && !bIsMen) {
                    return -1
                }
                if (!aIsMen && bIsMen) {
                    return 1
                }
            } else {
                if (aIsWomen && !bIsWomen) {
                    return -1
                }
                if (!aIsWomen && bIsWomen) {
                    return 1
                }
            }

            return 0
        })
    },
    /**
     * format category path
     *
     * @param path
     * @returns {string}
     */
    formatCategoryPath(path) {
        path = path.substring(0, path.lastIndexOf('/'))
            .replace(/\/+/g, ' > ')
            .replace(/-/g, ' & ') + ' >'

        if (/\/(de|ch)\//.test(window.location.href)) {
            path = path.replace(/\b\w/g, l => l.toUpperCase())
                .replace(/ae/g, 'ä')
                .replace(/oe/g, 'ö')
                .replace(/ue/g, 'ü')
        }

        return path
    }
}

export default topSearchCategories
